var React = require('react');

function TripleArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.211199 2.818L2.5422 5.065L0.211199 7.333V9.664L4.6212 5.149V5.002L0.211199 0.487V2.818Z","fill":"#FFCCAA","key":0}),React.createElement("path",{"d":"M8.01484 2.818L10.3458 5.065L8.01484 7.333V9.664L12.4248 5.149V5.002L8.01484 0.487V2.818Z","fill":"#FF9D5C","key":1}),React.createElement("path",{"d":"M15.8185 2.818L18.1495 5.065L15.8185 7.333V9.664L20.2285 5.149V5.002L15.8185 0.487V2.818Z","fill":"#FF6600","key":2})]);
}

TripleArrow.defaultProps = {"width":"21","height":"10","viewBox":"0 0 21 10","fill":"none"};

module.exports = TripleArrow;

TripleArrow.default = TripleArrow;
